/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * PassNotification.jsx
 * Created by Destin Frasier on 01/19/21
 * This is controled via the launchdarkly "pass-alert" flag.
 */

import React from 'react';
import { DisplayHtmlContent, useFlags, Alert, FlexRow, FlexCol } from 'sarsaparilla';

export default function PassNotification() {
    const { passAlert } = useFlags();

    // Bail if no data from LaunchDarkly
    if (!passAlert) {
        return null;
    }

    const [title, headingLevel, alertContent, alertType, className] = passAlert;

    const isOff = !Array.isArray(passAlert) || passAlert.length === 0;

    // Don't show if the flag is set to off
    if (isOff) {
        return null;
    }

    let decodedAlertBody = '';
    try {
        decodedAlertBody = decodeURIComponent(alertContent);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        decodedAlertBody = '';
    }

    return (
        <FlexRow>
            <FlexCol xl={8} xlOffset={2}>
                <Alert
                    type={alertType}
                    headingLevel={headingLevel}
                    heading={title}
                    className={className}
                >
                    <DisplayHtmlContent html={decodedAlertBody} />
                </Alert>
            </FlexCol>
        </FlexRow>
    );
}
